<template>
    <div class="flex-box nopadding line1">
        <div class="mg-right3" v-if="title != ''">{{title}}</div>
        <div>
            <el-dropdown trigger="click" @command="onChange">
                <span class="el-dropdown-link hand" :class="title_class">
                    {{select_text}}
                    <Icon type="ios-arrow-down"></Icon>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="index" v-for="(item,index) in list" :key="index">{{item[key_name]}}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
    export default {
        name: "myDropdown",
        model:{ //通过v-model传过来的参数
            prop: 'value',
            event: 'emitValue'
        },
        props:{
            list: {
                default: () => [],
                type: Array,
            },
            key_name: {
                default: "value",
                type: String,
            },
            value_name: {
                default: "key",
                type: String,
            },
            title:{
                default: "",
                type: String,
            },
            value: {
                default: "",
            },
            title_class: {
                default: "",
                type: String,
            }
        },
        data: function () {
            return{
            }
        },
        computed:{
            select_text:function() {
                var items = this.list.filter(item => item[this.value_name] == this.value);
                if(items.length > 0){
                    return items[0][this.key_name];
                }
                else{
                    return '';
                }
            },
        },
        methods: {
            onChange: function(data){
                this.$emit("emitValue",this.list[data][this.value_name]);
                this.$emit("onChange",this.list[data]);
            },
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myDropdown.vue